export default __webpack_public_path__ + "static/cta-subscribe-bg-tablet-a242898d82584becf9a4775ff4f32b75.png";